import ADD_PRODUCT_CERTIFICATE from 'api/mutations/ADD_PRODUCT_CERTIFICATE';
import REMOVE_PRODUCT_CERTIFICATE from 'api/mutations/REMOVE_PRODUCT_CERTIFICATE';
import UPDATE_PRODUCT_CERTIFICATE from 'api/mutations/UPDATE_PRODUCT_CERTIFICATE';
import GET_PRODUCT_CERTIFICATES from 'api/queries/GET_PRODUCT_CERTIFICATES';
import { createProductParameterSlice } from './createProductParameterSlice';
const productCertificatesSlice = createProductParameterSlice({
    name: 'productCertificates',
    stateKey: 'productCertificates',
    query: GET_PRODUCT_CERTIFICATES,
    addMutation: ADD_PRODUCT_CERTIFICATE,
    updateMutation: UPDATE_PRODUCT_CERTIFICATE,
    removeMutation: REMOVE_PRODUCT_CERTIFICATE,
    idVariableName: 'productCertificateId',
    selectConnection: (data) => data.autocomplete.productCertificates,
    selectAddedItem: (data) => data.addProductCertificate.productCertificate,
    selectUpdatedItem: (data) => data.updateProductCertificate.productCertificate,
});
export const resetProductCertificates = productCertificatesSlice.reset;
export const fetchProductCertificates = productCertificatesSlice.fetchItems;
export const addProductCertificate = productCertificatesSlice.addItem;
export const updateProductCertificate = productCertificatesSlice.updateItem;
export const removeProductCertificate = productCertificatesSlice.removeItem;
export const selectProductCertificates = productCertificatesSlice.selectItems;
export const selectProductCertificateById = productCertificatesSlice.selectItemById;
export const selectProductCertificatesPageInfo = productCertificatesSlice.selectPageInfo;
export const selectProductCertificatesStatus = productCertificatesSlice.selectStatus;
export const selectProductCertificatesErrors = productCertificatesSlice.selectErrors;
export const selectProductCertificatesRefetchFlags = productCertificatesSlice.selectRefetchFlags;
export default productCertificatesSlice.reducer;
